import React from 'react';
import { classNames } from '../../utils/style';
import { ImageTabs } from '../../layouts/ImageTabs';
import { container } from '../../styles/themes';
import { textTitle1 } from '../../styles/typography';

import { ButtonV2Props } from '../../components/ButtonV2';
import { ImageProps } from '../../components/Image/types';
export interface ImageTabSectionProps {
  title: string;
  text: string;
  picto?: string;
  selected?: boolean;
  ctaButton?: ButtonV2Props;
  background: string;
  image?: ImageProps;
}

export interface ImageTabsSectionProps {
  data: any;
  title: string;
}

export const ImageTabsSection = ({ title, data }: ImageTabsSectionProps) => {
  return (
    <div
      className={classNames(
        'SectionImageTabs',
        container,
        'text-neutral-301 flex',
        'flex-col items-center',
      )}
    >
      <h2
        className={classNames(
          'mb-64 font-medium text-center md:w-6/12',
          textTitle1,
        )}
      >
        {title}
      </h2>
      <ImageTabs data={data} />
    </div>
  );
};
